import * as React from "react";
import { Grid } from "@mui/material";

import { Text } from "../../../components/general/typography";
import { CollapsableCard } from "../../../components/general/collapsable_card";
import { LiveControlChart } from "../../../components/metering_tab/live_metering";
import SchematicCard from "../../../components/schematic/schematic_card";
import { useSiteData } from "hooks/use_site";
import { LiveActionList } from "components/metering_tab/live_action_list";
import ConnectionCard from "../../../components/installation/connection_card";
// import AccesPowerCard from "components/schematic/acces_power_card";

export default function InstallationTab({ required_privilege }) {
  const { data: siteData } = useSiteData();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SchematicCard required_privilege={required_privilege} />
      </Grid>
      <Grid item xs={12}>
        <LiveControlLoopCard siteData={siteData} />
      </Grid>
    </Grid>
  );
}

function LiveControlLoopCard({ siteData }) {
  return (
    <CollapsableCard title="Live Control loop" startCollapsed={true}>
      {siteData && siteData.online ? (
        <>
          <LiveActionList />
          <LiveControlChart />
        </>
      ) : (
        <Text sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          No live data available, box offline
        </Text>
      )}
    </CollapsableCard>
  );
}
